import primaryComponents from "../../../primaryComponents";
import globalstyles from "../../../../assets/styles/base/globalPage.module.scss";
import { ArrowRight } from "../../../../assets/svgIcons";
import { useValidation } from "./useValidation";
import { useSmsCampaignContextForm } from "./useSmsCampaignContextForm";

export const SmsCampaignContextForm = ({
  smsCampaign = {},
  isEditMode = false,
}) => {
  const { formData, isLoading, setFormData, handleSubmitCampaign } =
    useSmsCampaignContextForm({ isEditMode, smsCampaign });

  const {
    control,
    formState: { errors },
    handleSubmit,
    trigger,
  } = useValidation({ ...formData });

  return (
    <>
      <form
        className={`${globalstyles.cardWithBorder}`}
        onSubmit={handleSubmit(handleSubmitCampaign)}
      >
        <primaryComponents.InputFieldV2
          control={control}
          name="title"
          isRequired
          label={"Campaign Name"}
          placeholder={"Enter your campaign name"}
          value={formData?.title}
          classNames="white"
          errorMessage={errors?.title}
          onKeyUp={() => errors?.title && trigger("title")}
          onChange={({ target: { value } }) => {
            setFormData((prev) => ({ ...prev, title: value }));
          }}
        />

        <primaryComponents.TextArea
          control={control}
          name="description"
          label={"Campaign Description"}
          placeholder={"Enter your campaign descriptions"}
          value={formData?.description}
          onChange={({ target: { value } }) => {
            setFormData((prev) => ({ ...prev, description: value }));
          }}
        />

        <div className="mt-4">
          <primaryComponents.Button
            classNames={"btn btn--primary ml-auto"}
            isLoading={isLoading}
            isDisabled={isLoading}
            loadingText={"Processing..."}
            type="submit"
          >
            Next: Select Audience <ArrowRight className="ml-1" />
          </primaryComponents.Button>
        </div>
      </form>
    </>
  );
};
